import { UpdateRevisionedLineItemResponseSchema, type UpdateRevisionedLineItemResponse } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { UpdateRevisionedLineItemRequest } from './use-update-revisioned-line-item-types/update-revisioned-line-item-request';

export function useUpdateRevisionedLineItem(options?: UseMutationOptions<UpdateRevisionedLineItemResponse, unknown, UpdateRevisionedLineItemRequest>) {
  return useMutation({
    mutationFn: async (updateRevisionedLineItemRequest) => {
      const lineItemsApi = getPrivateApi();
      const updateRevisionedLineItemResponse = await lineItemsApi.updateRevisionedLineItem(updateRevisionedLineItemRequest);

      return UpdateRevisionedLineItemResponseSchema.parse(updateRevisionedLineItemResponse);
    },
    ...options,
  });
}